export default __webpack_public_path__ + "static/media/gruszka4a.857199c9.png";